export default __webpack_public_path__ + "static/media/kolobezka_konfety.d8bc63c5.jpg";